<template>
    <h2 class="h2">{{ t('step1.title') }}</h2>
    <p>{{ !selected ? t('step1.text') : t('step1.selectedStation') }}: <strong>{{ selected?.name }}</strong></p>
    <DSInput
        v-model="search"
        :label="t('step1.chooseStation')"
    />
    <button
        v-for="station in computedStations"
        :key="station.name"
        :class="{
            active: order.data.value.station === station.id
        }"
        class="result"
        @click="order.data.value.station = station.id"
    >
        <div>{{ station.name }}</div>
        <BlocksOpeningHours
            :opening-hours="station.openingHoursTable.station"
        />
    </button>
</template>
<script setup>
import { ref, computed, inject, useI18n } from '#imports';

const order = inject('order');
const search = ref('');

const props = defineProps({
    stations: {
        type: Array,
        required: false,
        default: () => [],
    },
    selected: {
        type: [Object, null],
        required: false,
        default: null,
    },
});

defineOptions({
    name: 'MMStep1',
    inheritAttrs: false,
});

const computedStations = computed(() => props.stations.filter(station => search.value ? station.name.toLowerCase().includes(search.value.toLowerCase()) : true ));

const { t } = useI18n({
    useScope: 'global',
    messages: {
        'fi-FI': {
            step1: {
                title: 'Mistä haluatte hakea?',
                text: 'Valitse asema alla olevasta listasta',
                chooseStation: 'Hae asema',
                selectedStation: 'Valittu asema',
            },
        },
    },
});
</script>
<style scoped>
.result {
  transition: all 0.2s ease-in-out;
  padding: 1rem 1.5rem;
  display: grid;
  grid-template-columns: 0.6fr 0.4fr;
  grid-gap: 1rem;
  width: 100%;
  font-weight: bold;
  text-align: left;
  border: 1px solid var(--color-base-grey-200);
  margin-bottom: 0.5rem;
  border-radius: 0.25rem;
}
.result .open-hours {
  color: var(--color-primary-500);
  font-size: 0.875rem;
}
.result.active {
  background-color: var(--color-primary-500);
  border-color: var(--color-primary-500);
  color: var(--color-base-white);
}
.result.active .open-hours {
  color: var(--color-base-white);
}
</style>
